const { makeRequest } = require('services/api/ufeApi');
const catalogUtils = require('utils/Catalog');
const { getCurrentCountry, getCurrentLanguage } = require('utils/LanguageLocale');

// https://jira.sephora.com/browse/INFL-1011

function getGroupedBrandsList() {
    let url = '/api/catalog/groupedBrandsList';

    if (catalogUtils.isBXSServiceEnabled()) {
        const channel = 'rwd';
        const language = getCurrentLanguage()?.toLowerCase();
        const country = getCurrentCountry();
        const paramsString = `?ch=${channel}&loc=${language}-${country}`;

        url = `/api/v2/catalog/groupedBrandsList${paramsString}`;
    }

    return makeRequest(url).then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = { getGroupedBrandsList };
